<template>
  <div class="text-center justify-content-center mb-3" style="padding-top: 10%">
    <b-spinner
        label="Παρακαλώ περιμένετε"
        style="width: 6rem; height: 6rem;"
        :variant="variant"
        :key="variant"
        type="border"
    ><span>Παρακαλώ περιμένετε..</span></b-spinner>
  </div>
</template>
<script>
export default {
  name: "BaseBSpinner",
  props: {
    variant: {
      default: 'primary',
      require: false,
      type: String
    },
  }
}
</script>

<style scoped>

</style>